$(document).ready(function () {
  $('.center-image-content-inner-resp .glide').each(function () {
    const $glide = $(this);

    const glideInstance = new Glide($glide[0], {
      type: 'slider',
      perView: 1,
      gap: 0,
      rewind: false,
      bound: true,
    });

    const $prevArrow = $glide.find(".glide__arrow--left");
    const $nextArrow = $glide.find(".glide__arrow--right");

    $prevArrow.on('click', function () {
      glideInstance.go('<');
    });

    $nextArrow.on('click', function () {
      glideInstance.go('>');
    });

    function updateArrows() {
      const index = glideInstance.index;
      const totalSlides = $glide.find(".glide__slide:not(.glide__slide--clone)").length;
      const maxIndex = totalSlides - 1;
    
      if (index <= 0) {
        $prevArrow.addClass("disabled");
      } else {
        $prevArrow.removeClass("disabled");
      }
    
      if (index >= maxIndex) {
        $nextArrow.addClass("disabled");
      } else {
        $nextArrow.removeClass("disabled");
      }
    }

    glideInstance.on(["mount.after", "run.after"], updateArrows);

    glideInstance.mount();
  });
});